import { render, staticRenderFns } from "./WorkflowPanel.vue?vue&type=template&id=794ae08b&scoped=true&"
import script from "./WorkflowPanel.vue?vue&type=script&lang=ts&"
export * from "./WorkflowPanel.vue?vue&type=script&lang=ts&"
import style0 from "./WorkflowPanel.vue?vue&type=style&index=0&id=794ae08b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "794ae08b",
  null
  
)

export default component.exports